import { Schema } from 'effect';

// Pass-through JSON of the admin onboarding payloads: Effect's own JSON
// schemas, recursive, so OpenAPI publishes them as a `$ref` cycle.
export const jsonValueSchema = Schema.Json.annotate({
  title: 'Power onboarding JSON value',
  description: 'JSON value for Power Admin pass-through payloads.',
});
export type JsonValue = typeof jsonValueSchema.Type;

export const jsonObjectSchema = Schema.JsonObject.annotate({
  title: 'Power onboarding JSON object',
  description: 'JSON object for Power Admin pass-through payloads.',
});
export type JsonObject = typeof jsonObjectSchema.Type;
